import omitBy from 'lodash.omitby'
import isNil from 'lodash.isnil'
import {
  getIdsFromArray,
  normalizeBusinessAccountIds,
} from '@/utils/utils'
import { adaptTaxonomySkillsToStore } from '@/utils/skills'
import {
  CUSTOM_CONTENT_AUDIENCE_TYPES,
  CUSTOM_CONTENT_FIELDS,
} from '@/constants/customContent'

export function adaptCourseToApi(course = {}) {
  let payload = {
    name: course.name,
    slug: course.slug,
    url: course.url,
    description: course.description,
    instructors: course.instructors,
    difficulty: course.difficulty,
    learning_areas: course.learning_areas,
    main_learning_area: course.main_learning_area,
    categories: course.categories,
    vendor: course.vendor,
    tags: course.tags,
    duration_in_seconds: course.duration_in_seconds,
    files_uuids: course.files_uuids,
    content: adaptContentToApi(course.content),
    status: course.status,
    auto_publish_at: course.auto_publish_at ? new Date(course.auto_publish_at).toISOString() : null,
    trailer_jwplayer_id: course.trailer_jwplayer_id,
    company: course.company,
    is_featured: course.is_featured,
    has_cc: course.has_cc,
    under_construction: course.under_construction,
    bootcamp_origin: course.bootcamp_origin,
  }

  if (
    Object.prototype.hasOwnProperty.call(
      course,
      CUSTOM_CONTENT_FIELDS.AUDIENCE_TYPE
    )
  ) {
    payload[CUSTOM_CONTENT_FIELDS.AUDIENCE_TYPE] =
      course[CUSTOM_CONTENT_FIELDS.AUDIENCE_TYPE]
  }

  if (
    Object.prototype.hasOwnProperty.call(
      course,
      CUSTOM_CONTENT_FIELDS.BUSINESS_ACCOUNT_IDS
    )
  ) {
    payload[CUSTOM_CONTENT_FIELDS.BUSINESS_ACCOUNT_IDS] =
      normalizeBusinessAccountIds(
        course[CUSTOM_CONTENT_FIELDS.BUSINESS_ACCOUNT_IDS]
      )
  }

  payload = omitBy(payload, isNil)
  // difficulty, vendor and main_learniing_area can be null
  payload.main_learning_area = course.main_learning_area
  payload.difficulty = course.difficulty
  payload.vendor = course.vendor
  return payload
}

export function adaptCourseToCreateApi(course = {}) {
  return adaptCourseToApi(course)
}

export function adaptCourseToStore(course = {}) {
  /// MOCK ///
  course.data.access = course.data.access ? course.data.access : {
    related_passes: []
  }
  ///////////
  const {
    assigned_accounts: legacyAssignedAccounts,
    ...courseData
  } = course.data
  const courseStore = {...courseData,
    vendor: courseData.vendor ? courseData.vendor.id : null,
    instructors: getIdsFromArray(courseData.instructors),
    learning_areas: getIdsFromArray(courseData.learning_areas),
    categories: getIdsFromArray(courseData.categories),
    [CUSTOM_CONTENT_FIELDS.AUDIENCE_TYPE]:
      courseData[CUSTOM_CONTENT_FIELDS.AUDIENCE_TYPE] ||
      CUSTOM_CONTENT_AUDIENCE_TYPES.PUBLIC,
    [CUSTOM_CONTENT_FIELDS.BUSINESS_ACCOUNT_IDS]: normalizeBusinessAccountIds(
      Array.isArray(courseData[CUSTOM_CONTENT_FIELDS.BUSINESS_ACCOUNT_IDS])
        ? courseData[CUSTOM_CONTENT_FIELDS.BUSINESS_ACCOUNT_IDS]
        : legacyAssignedAccounts
    ),
    access: {
      ...courseData.access,
      related_passes: courseData.access.related_passes
    }
  }

  if (Array.isArray(courseData.taxonomy_skills)) {
    courseStore.taxonomy_skills = adaptTaxonomySkillsToStore(courseData.taxonomy_skills)
  }

  return courseStore
}

export function adaptCoursesToStore(courses = []) {
  const courseList = {
    entries: courses.data.results.reduce((acc, course) => {
      acc[course.id] = adaptCourseToStore({ data: course })
      return acc
    }, {}),
    next: courses.data.next,
    previous: courses.data.previous,
    count: courses.data.count,
    results: courses.data.results.reduce((acc, course) => {
      acc.push(adaptCourseToStore({
        data: course
      }))
      return acc
    }, []),
  }
  return courseList
}

/**
 * delete all duration_in_seconds from content
 */
function adaptContentToApi(content) {
  if (!content) return content
  for (let i = 0; i < content.length; i++) {
    let element = content[i];
    if ('duration_in_seconds' in element) {
      delete element.duration_in_seconds
    }
    if (element.content && element.content.length) {
      for (let j = 0; j < element.content.length; j++) {
        let elementB = element.content[j];
        if ('duration_in_seconds' in elementB) {
          delete elementB.duration_in_seconds
        }
        if (elementB.content && elementB.content.length) {
          for (let j = 0; j < elementB.content.length; j++) {
            let elementC = elementB.content[j];
            if ('related' in elementC) {
              delete elementC.related
            }
          }
        }
      }
    }
  }
  return content
}
